import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";
import {
  CLOSED_SIDEBAR_WIDTH,
  EXPANDED_SIDEBAR_WIDTH, HEADER_BAR_HEIGHT
} from "../../../../../constants/fixedStyleVariables";

export const Sidebar = styled.div`
  z-index: 9999;
  position: absolute;
  top: ${HEADER_BAR_HEIGHT}px;
  height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
  max-height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
  overflow-y: auto;
  ${props => {
    if (props.expand) {
      return ` width: ${EXPANDED_SIDEBAR_WIDTH}px; `;
    } else {
      return `
				width: ${CLOSED_SIDEBAR_WIDTH}px;
				span.list-item-text {
					display: none;
				}
			`;
    }
  }};
  background-color: ${Variables.colors.complementary};
  border-left: 1px solid ${Variables.colors.complementary_400};
  direction: ltr;
  text-align: right;

  .sidebar-list {
    ul {
      ${props => {
        if (props.expand) {
          return `
                padding: 13px 0 0 8px;
                margin: 8px 0 0 0;
          `;
        } else {
          return `
                margin: 8px auto 0 auto;
                padding: 13px 0 0 0;
          `;
        }
      }};
    }

    direction: rtl;
    min-height: calc(100vh - 250px);
    a {
      color: ${Variables.colors.complementary_900};
      text-decoration: none;
      &:hover,
      &:active,
      &:visited {
        color: ${Variables.colors.complementary_900};
      }
      li {
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        list-style: none;
        text-align: right;
        direction: rtl;
        font-size: ${Variables.font_sizes.x_small};
        position: relative;
        ${props => {
          if (props.expand) {
            return `
                   width: auto;
                   height: 32px;
                   margin: auto;
                   padding: 8px 26px 8px 0;
                   border-radius: unset;
            `;
          } else {
            return `
                    width: 32px;
                    height: 32px;
                    margin: 0 auto 2px auto;
                    padding: 0 7px 0 0;
                    border-radius: 50%;
            `;
          }
        }}

        .sidebar-badge {
          background-color: ${Variables.colors.red_600};
          position: absolute;
          top: 8px;
          left: 8px;
          ${props => {
            if (props.expand) {
              return `
                    width: 16px;
                    height: 16px;
                    border-radius: 32px;
                    top: 8px;
                    left: 8px;
					`;
            } else {
              return `
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    top: 0;
                    left: 0;
                    `;
            }
          }};
          span {
            ${props => {
              if (props.expand) {
                return `
                        display: block;
                        font-family: Number, sans-serif;
                        color: ${Variables.colors.complementary};
                        display: block;
                        text-align: center;
                        padding-top: 2px;		
                `;
              } else {
                return `
                        display: none;
                `;
              }
            }};
          }
        }

        i {
          &:before {
            color: ${Variables.colors.complementary_600};
            margin-left: 9px;
            font-size: 18px;
          }
        }
        .image-icon {
          margin-left: 9px;
          width: 16px;
          height: 16px;
        }
        .svg-icon-wrapper {
          margin-left: 8px;
          display: flex;
          path {
            fill: ${Variables.colors.primary_vivid};
            stroke: ${Variables.colors.primary_vivid};
          }
        }

        &:hover {
          background-color: ${Variables.colors.complementary_200};
          ${props => {
            if (props.expand) {
              return `
                    border-radius: 4px;
                    padding: 8px 26px 8px 0;	
            `;
            } else {
              return `
                    border-radius: 50%;
                    padding: 0 7px 0 0;
            `;
            }
          }};
        }
      }
    }
    a.list-item-active {
      li {
        background-color: ${Variables.colors.primary_50};
        color: ${Variables.colors.primary_vivid};
        &:hover,
        &:active,
        &:visited {
          color: ${Variables.colors.primary_vivid};
        }
        ${props => {
          if (props.expand) {
            return `
                    border-radius: 4px 0 0 4px;
                    padding: 8px 26px 8px 0;		
            `;
          } else {
            return `
                    border-radius: 50%;
                    padding: 0 7px 0 0;
            `;
          }
        }};
        i {
          &:before {
            color: ${Variables.colors.primary_vivid};
          }
        }
      }
    }
  }
  .sidebar-footer {
    margin-right: 12px;
    padding: 20px 11px 0 4px;
    direction: rtl;
    text-align: right;
    height: 104px;
    background-color: ${Variables.colors.complementary};
    a {
      text-decoration: none;
      color: ${Variables.colors.complementary_600};
      &:hover,
      &:visited,
      &:focus {
        color: ${Variables.colors.complementary_600};
      }
    }
    .circle-separator {
      width: 4px;
      height: 4px;
      display: inline-block;
      vertical-align: middle;
      margin: 0 2px;
      content: " ";
      border-radius: 50%;
      background-color: ${Variables.colors.complementary_700};
    }
    div {
      ${props => {
        if (props.expand) {
          return `
                color: ${Variables.colors.complementary_600};
                font-size: ${Variables.font_sizes.x_small};
                padding-bottom: 7px;
        `;
        } else {
          return `
                display: none;
        `;
        }
      }};
    }
    .minimum-mode-icon {
      a {
        i {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          &:before {
            color: ${Variables.colors.complementary_600};
            margin-left: 0;
          }
          &:hover {
            background-color: ${Variables.colors.complementary_200};
          }
        }
      }
      ${props => {
        if (props.expand) {
          return `display: none;`;
        } else {
          return `display: block;`;
        }
      }};
    }
  }
  @media (max-width: 1199px) {
    ${props => {
      if (!props.expand) {
        return `
					& {
						width: ${CLOSED_SIDEBAR_WIDTH}px;
						span.list-item-text {
							display: none;
						}
						
						ul.sidebar-list {
							margin: 16px auto 0 auto;
							padding: 12px 0 0 0;
							a {
								li {
									width: 32px;
									height: 32px;
									margin: 0 auto 2px auto;
									padding: 0 7px 0 0;
									border-radius: 50%;
									position: relative;
									
									.sidebar-badge {
										background-color: ${Variables.colors.red_600};
										width: 8px;
										height: 8px;
										border-radius: 50%;
										position: absolute;
										top: 0;
										left: 0;
										span {
											display: none;
										}
									}
									
									&:hover {
										border-radius: 50%;
										padding: 0 7px 0 0;
									}
								}
							}
							.list-item-active {
								border-radius: 50%;
								padding: 0;
							}
						}
					}
					.sidebar-footer {
						div {
							display: none;
						}
						.minimum-mode-icon {
							display: block;
						}
					}
				`;
      }
    }}
  }
`;

export const DashboardBody = styled.div`
  margin-top: 65px;
  background-color: ${Variables.colors.complementary};
  //max-height: calc(100vh - 123px);
  max-height: calc(100vh - 65px);
  //margin-bottom: 58px;
  overflow-y: auto;
  ${props => {
    if (props.expand) {
      return `
				margin-right: ${EXPANDED_SIDEBAR_WIDTH}px;
			`;
    } else {
      return `
				margin-right: ${CLOSED_SIDEBAR_WIDTH}px;
			`;
    }
  }}

  .dashboard-container {
    width: 100%;
    min-width: 922px;
    min-height: calc(100vh - 100px);
    //height: auto;
    overflow-x: auto;
    overflow-y: hidden;
  }
  @media (max-width: 1199px) {
    ${props => {
      if (!props.expand) {
        return `
					& {
						margin-right: ${CLOSED_SIDEBAR_WIDTH}px;
					}
				`;
      }
    }}
  }
`;
